import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBX3VlETyFEDXuiqE7VsZucpDMKRPaqPtU",
  authDomain: "gd-evaluation-system.firebaseapp.com",
  projectId: "gd-evaluation-system",
  storageBucket: "gd-evaluation-system.appspot.com",
  messagingSenderId: "980766251069",
  appId: "1:980766251069:web:d3941065a46e4f8a2b7254"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const provider = new GoogleAuthProvider();

const db = getFirestore(app);  

export { auth, provider, db }; 